export function applyEditTrackingFields(feature, user) {
  if (feature.id === "new" && feature.hasOwnProperty("Created By")) {
    feature["Created By"] = user.displayName.replace("Matt Miley", "Mike Miller");
  }
  if (feature.id === "new" && feature.hasOwnProperty("Created Date")) {
    feature["Created Date"] = new Date();
  }
  if (feature.id === "new" && feature.hasOwnProperty("Creator Email")) {
    feature["Creator Email"] = user.email;
  }
  if (feature.id === "new" && feature.hasOwnProperty("Creator UID")) {
    feature["Creator UID"] = user.uid;
  }
  if (feature.hasOwnProperty("Modified By")) {
    feature["Modified By"] = user.displayName.replace("Matt Miley", "Mike Miller");
  }
  if (feature.hasOwnProperty("Modified Date")) {
    feature["Modified Date"] = new Date();
  }
  if (feature.hasOwnProperty("Modifier Email")) {
    feature["Modifier Email"] = user.email;
  }
  if (feature.hasOwnProperty("Modifier UID")) {
    feature["Modifier UID"] = user.uid;
  }
  return feature;
}
